import smoothscroll from "smoothscroll-polyfill";
import { SmoothScrollToTarget } from "../tfs-utilities";
import Analytics from "../analytics";

// kick off the polyfill!
smoothscroll.polyfill();

const SplashImages = {
  data: {
    splashImageSelector: ".js-splash-image",
    headerSelector: "#tfs-daily-dose-header",
    gtmEvent: "click-splash-button",
    gtmAction: "click splash button"
  },

  init() {
    this.scrollToHeader();
  },

  scrollToHeader() {
    const button = document.querySelector(
      `[data-scroll-target='${this.data.headerSelector}']`
    );
    if (button) {
      button.onclick = function didClick() {
        SplashImages.doScroll(button.getAttribute("data-scroll-target"));
        SplashImages.sendGTMEvent(
          SplashImages.data.gtmAction,
          window.location.href
        );
      };
    }
  },

  doScroll(selector) {
    const target = document.querySelector(selector);
    const navBuffer = -60;
    SmoothScrollToTarget(target, navBuffer);
  },

  sendGTMEvent(action, label) {
    Analytics.track(SplashImages.data.gtmEvent, {
      action,
      label
    });
  }
};
export default SplashImages;
